import {isString, get} from "lodash";
import {SagaIterator} from "redux-saga";
import {put, call, select} from "redux-saga/effects";
import {isAuthedSelector} from "modules/selectors";
import {ISagaAction} from "modules/types";
import {User} from "modules/utils/User";
import {cleanUpAuth, errorsShowGlobalError, setGlobalLoaderStateAction} from "modules/actions";
import {ApiError} from "modules/utils/Api";

type TPayload = TypeError | Error | string;

const defaultErrorHandler = (payload: TPayload) => {
	if (payload instanceof TypeError) {
		console.error(payload);
		return;
	}

	if (isString(payload)) {
		throw new Error(payload);
	}

	if (isString(payload.message)) {
		throw new Error(payload.message);
	}
};

export const errorsManagerSaga = function* ({payload}: ISagaAction<TPayload>): SagaIterator {
	const onError = {
		*[ApiError.AUTH_REQUIRED](error: TPayload): SagaIterator {
			const isAuthed = yield select(isAuthedSelector);

			if (isAuthed) {
				User.CLEAR();
				yield put(cleanUpAuth());
			}

			defaultErrorHandler(error);
		},
	};

	try {
		const error_code = get(payload, "code", "");
		const onErrorHandler = get(onError, error_code, defaultErrorHandler);

		yield call(onErrorHandler, payload);
	} catch (e) {
		const err = e as Error;
		yield put(
			errorsShowGlobalError({
				text: err.message,
			})
		);
		yield put(setGlobalLoaderStateAction(false));
	}
};
